// export const DEFAULT_BROWSE_APP = '/public/browse'
export const DEFAULT_BROWSE_APP = '/'

export const OVERRIDE_STATUS_MAPPING_RULES = {
  avail: 'For Sale',
  unavail: 'Not For Sale',
  sold: 'Sold',
}

export const OVERRIDE_ORIGINAL_AVAILABILITY_STATUS_MAPPING_RULES = {
  avail: 'Available',
  unavail: 'Not Available',
  sold: 'Sold',
  reserved: 'Reserved',
}

export const OVERRIDE_CATEGORY_MAPPING_RULES = {
  ['mixed-media']: 'Mixed Media',
}

export const OVERRIDE_SORT_MAPPING_RULES = {
  default: 'Recommended',
  newest: 'Date Listed: New to Old',
  'price-low': 'Price: Low to High',
  'price-high': 'Price: High to Low',
  oldest: 'Date Listed: Old to New',
}

export const OVERRIDE_MATERIALS_MAPPING_RULES = {
  rag: 'Fine Art Paper',
  canvas: 'Canvas',
  photo: 'Photo Paper',
  acrylic: 'Acrylic',
  metal: 'Metal',
}

export const OVERRIDE_ORIENTATION_MAPPING_RULES = {
  landscape: 'Horizontal',
  portrait: 'Vertical',
  square: 'Square',
}

export const BOOLEAN_FACETS_MAPPING_VALUE = {
  is_outdoor: 'outdoor',
  is_outdoor_safe: 'outdoor',
}

export const OVERRIDE_IS_OUTDOOR_MAPPING_RULES = {
  is_outdoor: 'outdoor',
  is_outdoor_safe: 'outdoor',
}

export const OVERRIDE_CURATED_STATUS_MAPPING_RULES = {
  ['-1']: 'Curated Down',
  ['0']: 'Not Curated',
  ['1']: 'Curated Up',
  ['down']: 'Curated Down',
  ['not-curated']: 'Not Curated',
  ['up']: 'Curated Up',
}

export const OVERRIDE_READY_TO_HANG_MAPPING_RULES = {
  ['true']: 'Ready To Hang',
  ['false']: 'Not Ready To Hang',
}

export const OVERRIDE_FRAMED_MAPPING_RULES = {
  ['true']: 'Framed',
  ['false']: 'Not Framed',
}

export const OVERRIDE_OUTDOOR_SAFE_MAPPING_RULES = {
  ['true']: 'Outdoor Safe',
  ['false']: 'Not Outdoor Safe',
}

export const OVERRIDE_PACKAGING_MAPPING_RULES = {
  ['rolled']: 'Tube',
  ['flat-cardboard']: 'Box',
  ['flat-crate']: 'Crate',
  ['flat_cardboard']: 'Box',
  ['flat_crate']: 'Crate',
}

export const OVERRIDE_INSTALLATION_TYPE_MAPPING_RULES = {
  ['wall_mounted']: 'Wall-Mounted',
  ['free_standing']: 'Free-Standing',
}

export const CATEGORY_SPECIFIC_FACETS_ALGOLIA: Record<string, string[]> = {
  Sculpture: ['is_outdoor', 'is_outdoor_safe', 'installation_type'],
  Installation: ['is_outdoor', 'is_outdoor_safe', 'installation_type'],
}
